<template>
  <InputText
    :filtro="filtro"
    @aplicarFiltro="aplicarFiltro"
    v-model:text="text"
    :path="path"
  />
</template>
<script>
import ExibicaoInputText from '../../components/ExibicaoInputText.vue';
import InputText from '../../components/InputText.vue';
import mixinFiltro from '../../mixins/mixinFiltro';
export default {
  emits: ['excluirFiltro'],
  props: {
    filtro: {
      type: Object,
      required: true
    },
    path: {
      type: String,
      required: true
    }
  },
  components: {
    InputText,
    ExibicaoInputText
  },
  mixins: [mixinFiltro],
}
</script>
